import React from 'react';
import scrollToElement from 'scroll-to-element';
import prd from "../../Core/Products";
import Slider from 'react-slick';
import {Modal} from 'react-bootstrap';
import call from "../../Core/Services";

import DocumentMeta from 'react-document-meta';

class ProductDescription extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.data = {
			productType: this.props.match.path.includes('cycle') ? 'CYCLE' : 'ACCESSORY',
			productURI: this.props.match.params.page_uri
		};

		this.state = {
			product : null,
			showModal: false,
			message : '',
		}		
	}

	getProduct = () => {

		prd.getProduct(this.data, (response) => {
			this.setState({
				product: response.data
			});
		});

	}

	componentWillMount() {
		this.getProduct();	
	}

	close = () => {
		this.setState({ showModal: false });
	}

	open = () => {
		this.setState({ showModal: true });
	}


	submitForm = ( e ) => {
        
        e.preventDefault();

        let formData = {
            'name'      : this.refs.name.value,
            'email'     : this.refs.email.value,
            'phone'     : this.refs.phone.value,
            'comment'   : this.refs.comment.value,
            'category'  : this.data.productType,

            'metaData'  : {
            	'title'   	: this.state.product.meta.title,
            	'url'  	  	: window.location.href,
            	'prod_id' 	: this.data.productType == 'CYCLE' ? this.state.product.meta.cyc_id : this.state.product.meta.acc_id 
            },
        };

        call.submitForm( formData, () => {
            
            this.refs.name.value    	= '';
            this.refs.email.value       = '';
            this.refs.phone.value       = '';
            this.refs.comment.value     = '';
    
            this.setState({
                message: 'Tak for din forespørgsel, vi svarer som regel i løbet af få timer'
            });

            setTimeout( () => {                
                this.setState({
                    message: ''
                });
            }, 10000)

        });


    }

	render() {
			
		if( this.state.product == null ) {
			return (
				<div className="loading-container"></div>
			)
		} else {

			let categories 	= [];
			let buildFor 	= [];

			if( this.data.productType === 'CYCLE' ){
				
				for(let i = 0; i < this.state.product.categories.length; i++){
					categories.push( this.state.product.categories[i].category_name )
				}
				categories = categories.toString();	
				
				if( this.state.product.meta.build_for.indexOf('M') > -1 ) {
					buildFor.push(<li>Herrecykler</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('F') > -1 ) {
					buildFor.push(<li>Damecykler</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('K') > -1 ) {
					buildFor.push(<li>Børnecykler</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('E') > -1 ) {
					buildFor.push(<li>Elektrisk</li>)	
				}
				if( this.state.product.meta.build_for.indexOf('A') > -1 ) {
					buildFor.push(<li>Alle</li>)	
				}

			} else{

			}

			let specifications = [];
			for(let i = 0; i < this.state.product.specifications.length; i++){
				specifications.push(
					<li>
						<div className="spec-item">
							<div className="key">
								{this.state.product.specifications[i].spec_name}
								<span className="value">{this.state.product.specifications[i].spec_value}</span>
							</div>	                							
						</div>
					</li>
				)
			}

			let settings = {
				dots: false,
				autoplay:true,
				infinite: true,
				speed: 500,
				autoplaySpeed: 10000,
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true,
				//lazyLoad: 'ondemand',
			};
			
			let sliderItem = [];
			
			sliderItem.push(
				<div className="image-slider">
					<div className="inner">
						<img src={this.state.product.meta.cloudinary_path + 'w_800/q_auto/' +this.state.product.meta.thumb_image_id } />					
					</div>
				</div>
			)

			for(let i = 0; i < this.state.product.images.length; i++){
				sliderItem.push(
					<div className="image-slider">
						<div className="inner">
							<img src={this.state.product.images[i].cloudinary_path + 'w_800/q_auto/' +this.state.product.images[i].image_id } />					
						</div>
					</div>
				)
			}

			const meta = {
	            title:          this.state.product.meta.title,
	            description:    this.state.product.meta.description,
	            meta: {
	                charset:    'utf-8',
	                name: {
	                    keywords: this.state.product.meta.title
	                }
	            }
	        };
			
			return (

				<div className="product-description-page">
                	
                	<DocumentMeta {...meta} />

	                <div className="container">
	                	
	                	<div className="row">	                		
	                		<div className="col-sm-12">
	                			<div className="row">
	                				<div className="col-md-8 col-sm-6 col-xs-12">
	                					<div className="slick-product-slider">          						
											<Slider {...settings} className="service-slider">									
												{sliderItem}
											</Slider>
											{
												this.data.productType === 'CYCLE' && (
													<div className="shimano-logo">
														<img src="../images/shimano-logo.png"/>
													</div>
												)
											}
	                					</div>
	                				</div>
	                				<div className="col-md-4 col-sm-6 col-xs-12">
	                					<div className="title-wrapper">
	                						<h2>
	                							<span>{categories}</span>
	                							{this.state.product.meta.title}
	                						</h2>

	                						<h2>
	                							<span>PRIS</span>
												{ this.state.product.meta.strike_price ? <s>DKK{this.state.product.meta.strike_price}</s> : null } { 'DKK' + this.state.product.meta.final_price}
	                						</h2>

	                						<div className="build-for">
	                							<div className="head">Bygget til</div>
	                							<ul>
	                								{buildFor}	                								
	                							</ul>
	                						</div>
	                						<div className="row">
											    <div className="col-md-6 col-sm-6 col-xs-6 col-xxs-12">
											    	<button type="button" className="btn btn-default btn-long btn-block" onClick={ () => scrollToElement('#full-specification') }>Mere specifikation</button>
											    </div>
											    <div className="col-md-6 col-sm-6 col-xs-6 col-xxs-12">
											    	<button type="button" className="btn btn-primary btn-long btn-block" onClick={this.open} >Forespørgsel nu</button>
											    </div>
											  </div>
	                					</div>
	                				</div>
	                			</div>
	                		</div>
	                	</div>
	                </div>


	                <div className="container">
	                	<div className="row" id="full-specification">
	                		<div className="col-md-8 col-md-offset-2 col-sm-12">
	                			<div className="description">
	                				<p className="text-center">{this.state.product.meta.description}</p>
	                			</div>

	                			<div className="spec-wrapper">
	                				<ul>
	                					{specifications}
	                				</ul>
	                			</div>
	                		</div>
	                		{
	                			this.data.productType === 'CYCLE' && (
			                		<div className="col-sm-12">
			                			<div className="row margin-bottom-80 guarantee-wrapper">
			                				<div className="col-sm-6 col-md-4">
			                					<div className="guarantee-item">
			                						<h4>Garanti</h4>
			                						<p>Vi tilbyder vores kunder 10 års garanti på ramme og et års gratis inspektion.</p>
			                					</div>
			                				</div>
			                				<div className="col-sm-6 col-md-4">
			                					<div className="guarantee-item">
			                						<h4>Retur og garanti</h4>
			                						<p>Vi tilbyder 14 dages returpolitik, men varen skal være ubrugt, og kvitteringen vil blive sendt samt 2 års garanti.</p>
			                					</div>
			                				</div>
			                				<div className="col-sm-6 col-md-4">
			                					<div className="guarantee-item">
			                						<h4>Betaling</h4>
			                						<p>Betaling kan ske ved hjælp af kontanter samt Dankort og MobilPay.</p>
			                					</div>
			                				</div>
			                			</div>	                			
			                		</div>

	                			)
	                		}

	                	</div>
	                </div>


					<Modal show={this.state.showModal} onHide={this.close}>
						<Modal.Header closeButton>
							<Modal.Title>Forhør nu for flere detaljer</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="row">
								<div className="col-md-12">
									
									<div className={ this.state.message ? 'alert alert-success show' : 'alert alert-success' }>
		                                <a className="close" onClick={ () => this.setState({message: '' }) } >&times;</a>
		                                { this.state.message }
		                            </div>

									<form role="form" id="enquire-form" method="post" onSubmit={ this.submitForm } >
										
										<div className="row">
											<div className="form-group col-md-6">
												<label className="sr-only" htmlFor="first-name">Dit navn</label>
												<input type="text" required ref="name" name="first-name" placeholder="Dit navn" minLength={3} maxLength={15} className="form-control" />
												<span className="error" />
											</div>
											<div className="form-group col-md-6">
												
												<label className="sr-only" htmlFor="phone-number">Telefonnummer</label>
												<input type="number" required ref="phone" name="phone-number" placeholder="Telefonnummer" className="form-control" />
												<span className="error" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-md-12">
												<label className="sr-only" htmlFor="email">Email adresse</label>
												<input type="email" required ref="email" name="email" placeholder="Email adresse" minLength={3} maxLength={50} className="form-control" />
												<span className="error" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-sm-12">
												<label className="sr-only">Forespørgselsdetaljer</label>
												<textarea required ref="comment" name="enquiry_details" className="form-control" minLength={10} maxLength={300} rows={5} placeholder="Indtast din forespørgsel her..." />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-xs-4">
												<input type="submit" name="Submit" className="btn btn-primary btn-block" defaultValue="Indsend" />
											</div>
										</div>
																		
									</form>

								</div>
							</div>
						</Modal.Body>
					</Modal>

				</div>
			);
		}
	}
}

export default ProductDescription;



// WEBPACK FOOTER //
// ./src/Pages/Products/ProductDescription.js